import { api } from './api';

// Types for Lapsed Partner Report
export interface LapsedPartnerReport {
  partner_id: number;
  partner_name: string;
  last_order_date: string | null;
  days_since_order: number;
  order_cycle_days: number;
  rating: number;
}

export interface LapsedPartnerReportResponse {
  total_count: number;
  partners: LapsedPartnerReport[];
}

// Types for Inventory Movement Report
export interface InventoryMovementEntry {
  date: string;
  order_id: number;
  partner_name: string;
  quantity: number;
  movement_type: 'INWARD' | 'OUTWARD' | 'RETURN';
}

export interface InventoryMovementResponse {
  data: InventoryMovementEntry[];
  meta: {
    page: number;
    limit: number;
    total: number;
  };
}

export interface InventoryMovementParams {
  item_id: number;
  start_date: string;
  end_date: string;
  partner_id?: number;
  page?: number;
  limit?: number;
  export?: boolean;
}

// Types for Sales Graph Report
export interface SalesGraphPoint {
  date: string;
  quantity: number;
}

export interface SalesGraphSeries {
  key: string;
  points: SalesGraphPoint[];
}

export interface SalesGraphResponse {
  duration: 'day' | 'month';
  group_by: 'none' | 'category' | 'product';
  series: SalesGraphSeries[];
}

export interface SalesGraphParams {
  start_date: string;
  end_date: string;
  category_id?: number;
  partner_id?: number;
  item_id?: number;
  state?: string;
  duration?: 'day' | 'month';
  group_by?: 'none' | 'category' | 'product';
}

export const reportService = {
  /**
   * Fetch lapsed partners report
   */
  getLapsedPartners: async (): Promise<LapsedPartnerReportResponse> => {
    const response = await api.get<LapsedPartnerReportResponse>('/api/reports/lapsed-partners');
    return response.data;
  },

  /**
   * Fetch inventory movements report
   */
  getInventoryMovements: async (params: InventoryMovementParams): Promise<InventoryMovementResponse> => {
    const response = await api.get<InventoryMovementResponse>('/api/stock-movements/inventory', { params });
    return response.data;
  },

  /**
   * Fetch sales graph report
   */
  getSalesGraph: async (params: SalesGraphParams): Promise<SalesGraphResponse> => {
    const response = await api.get<SalesGraphResponse>('/api/reports/sales-graph', { params });
    return response.data;
  },
};
